import React from 'react';
import styled from 'styled-components';
import { fonts, colors, Pill as DefaultPill, MegaphoneIcon as DefaultMegaphoneIcon, BodyLargeBold, BodyMediumRegular } from 'prospect-path-base';
import { Announcement, AnnouncementButton, OnboardingTour, ProgressBar, ProgressMeter, Section, Product } from 'prospect-path-components';
import PropTypes from 'prop-types';
import ActivitySection from './ActivitySection';

const { body } = fonts;
const { medium } = body;

const { teal } = colors;
const { defaultTeal, teal8 } = teal;

const Container = styled.section`
  background: ${teal8};
  height: 12.5rem;
  border-radius: 1rem;
  padding: 1.25rem;
  margin-bottom: 2.5rem;
`;

const Pill = styled(DefaultPill)`
  ${medium};
  background: #fff;
  color: ${defaultTeal};
`;

const MegaphoneIcon = styled(DefaultMegaphoneIcon)`
  margin-right: 0.375rem;

  svg path {
    fill: ${defaultTeal};
  }
`;

const WhatsNewSection = ({customCopy, ...props}) => {
  return (
      <Announcement {...props} style={{ maxWidth: '306px' }}>
          <div>
              <div style={{ marginBottom: '0.75rem' }}>
                  <BodyLargeBold as="h3">{customCopy.whats_new_title}</BodyLargeBold>

                  <BodyMediumRegular as="p">{customCopy.whats_new_body}</BodyMediumRegular>
              </div>

              <a href={customCopy.whats_new_link} style={{ textDecoration: 'none' }}
                 target={'_blank'}
              >
                  <AnnouncementButton>Find out more</AnnouncementButton>
              </a>
          </div>
      </Announcement>
  )
}

WhatsNewSection.defaultProps = {
    customCopy: {},
}

WhatsNewSection.propTypes = {
    customCopy: PropTypes.object,
}

export default WhatsNewSection;
